module.exports = __webpack_public_path__ + "img/trust-process1.4a9ff4ce.png";